<template>
  <div>

    <SGPTabelaComponent
      v-if="listagemUsuarios.length"
      titulo="Adicionar rota aos grupos"
      :colunas="colunas"
      :dados="listagemUsuarios"
      :usuarioPodeExcluir="false"
      :usuarioPodeEditar="false"
      :somenteLeitura="true"
      @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
      @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
      @sgpTabelaDeletarSelecionadoEmit="deletarSelecionados"
    ></SGPTabelaComponent>

    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPConfirmacaoDelecaoComponent
      v-if="abrirModalDeletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />
    
    <SGPLoadingComponent v-if="loadingGrupos" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import deletar from "@/././common/mixins/deletar.js";

export default {
  name: 'ListagemGrupoRotaComponent',
  mixins: [deletar],
  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      usuariosSelecionados: [],
      abrirModal: false,
      abrirModalDeletarDados: false,
      tipoFormulario: 'salvar',
      usuario: {}
    }
  },

  created () {
    this.listarGrupos()
  },

  computed: {
    ...mapGetters('grupos', ['listaDeGrupos','loadingGrupos']),

    listagemUsuarios () {
      return this.listaDeGrupos.map(usuario => {
        usuario.redirecionar = `grupo-rotas/${usuario.id}`
        return usuario
      })
    },

    colunas () {
      return [ 
        {
          key: 'grupo',
          label: 'Nome',
          sortable: false
        },
        {
          key: 'redirecionar',
          label: 'Menus',
          sortable: false
        }
      ]
    }
  },

  methods: {
    ...mapActions('grupos', [
      'listarGrupos',
      'deletarUsuario'
    ]),

    gerenciadorDeSelecionados (selecionados) {
      this.usuariosSelecionados = selecionados
    },

    adicionarNovoUsuario () {
      this.abrirModal = true
      this.tipoFormulario = 'salvar'
      this.usuario = {}
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar'
      this.usuario = this.usuariosSelecionados[0]
      this.abrirModal = true
    },

    confirmarDelecao () {
      this.deletarDados = false      
      console.log('Confirmou a deleção')

      this.usuariosSelecionados.forEach(async usuario => {
        await this.deletarUsuario(usuario); 
      })
    },

    fecharModal () {
      this.abrirModal = false
    }

  }
}
</script>
